$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    $('#checkout').addClass('disabled');
    $('.remove_line').addClass('disabled');
    $('.loading-overlay').css('opacity', '1');
  }
});

// Util
function toMoney(value) {
  var amount = Number(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return '$' + amount;
}

function toNumber(value) {
  return Number(value.replace(/[$,]+/g, ""));
}

function ajaxFinished() {
  $('#checkout').removeClass('disabled');
  $(".remove_line").removeClass('disabled');
  $('.loading-overlay').css('opacity', '0');
}

function redirectToDefault() {
  window.location.replace("/products");
}

function pluralize(count, singular, plural) {
  if (count === 0 || count > 1) {
    return count + " " + plural
  } else {
    return count + " " + singular
  }
}

// Tax
function resetPromotions() {
  return RegistriaShoppingCart.resetPromotions();
}

function calculateTax() {
  if (window.shoppingCart.shopping_cart_items < 1) { return resetPromotions(); }

  return RegistriaShoppingCart.calculateTax({
    success: function (data) {
      var tax = data.cart_tax;
      var total = data.cart_total;

      window.shoppingCart.cart_tax = tax;
      window.shoppingCart.cart_total = total;

      if (isNaN(toNumber(data.cart_tax))) {
        $("#tax").html($.polyglot.t('messages.tax_not_available'));
        $("#total").html(window.shoppingCart.cart_sub_total);
      } else {
        $("#tax").html(tax);
        $("#total").html(total);
      }
    }
  })
}

// Shipping
function resetShippingAmount() {
  window.shoppingCart.cart_shipping_total = "-";
  $('#shipping').html(toMoney(0));
}

function calculateShipping() {
  var shipping_rate = Number($("#shipping").data("shippingPrice"));
  var shipping_rate_money = toMoney(shipping_rate);
  var subtotal = toNumber(window.shoppingCart.cart_sub_total);
  var discount = toNumber(window.shoppingCart.cart_coupon_discount_total === "-" ? "$0.00" : window.shoppingCart.cart_coupon_discount_total);
  var tax = toNumber(window.shoppingCart.cart_tax);
  if (isNaN(shipping_rate)) {
    var total = subtotal - discount + tax;
  }
  else {
    var total = subtotal - discount + tax + shipping_rate;
  }
  var total_money = toMoney(total);
  var subtotal_money = toMoney(subtotal);
  $("#subtotal").html(subtotal_money);

  window.shoppingCart.cart_shipping_total = shipping_rate_money;
  window.shoppingCart.cart_total = total_money;
  var _shippingTotal = data.cart_shipping_and_handling_total;

  var display_shipping_rate_money = shipping_rate === 0 ? "FREE" : shipping_rate_money;
  $('#shipping').html(display_shipping_rate_money);
  $("#total").html(total_money);
}

function shippingEstimate() {
  if (window.shoppingCart.shopping_cart_items < 1) { return resetShippingAmount(); }

  return RegistriaShoppingCart.calculateShipping({
    success: function(data) {
      var shippingType = data["FEDEX_GROUND"];
      var $shippingMethod = $("#shipping");
      var shippingId = $("#shipping-form input[data-shipping-method='FEDEX_GROUND']").val()
      $shippingMethod.data("shippingPrice", shippingType["amount"]);
      $shippingMethod.html(toMoney(shippingType["amount"]));
      RegistriaShoppingCart.addOrUpdateShippingMethod(shippingId, {
        success: function() { calculateShipping(); }
      })
    },
    error: function() {
      window.shoppingCart.cart_shipping_total = $.polyglot.t('messages.shipping_not_available');
      $('#shipping').html(window.shoppingCart.cart_shipping_total);
      $('p#shipping').css('font-size', '75%');
      $('p#shipping').css('padding-left', '15px');
      $('p#shipping').css('text-align', 'right');
    }
  });
}

// Promotions
function update_shipping_amounts(promotion_type) {
  switch (promotion_type) {
    case "free_shipping":
    case "grouped_coupon":
      $("#shipping").data('shippingPrice', "0.0");
      break;
    default:
      break;
  }
}

function applyShippingPromotion(data) {
  if (data.promotion_type === "N") {
    $('#invalid-promo').css('display', 'block');
  } else {
    $('#invalid-promo').css('display', 'none');
    var codeDis = $("#promotion_code").val();
    if(codeDis.length > 0) {
      $('.promo-payment-drop').html('<p class="em2 promo-applied-msg" style="">Promo code &#34;' + codeDis + '&#34; applied</p>');
    }
    $('#shipping').html(data.cart_shipping_total);
    update_shipping_amounts(data.promotion_type);
    sessionStorage.setItem("promo_primary", codeDis);
  }
}

function applyOrderLinePromotion(data) {
  if (data.cart_coupon_discount_total === "-") {
    if (toNumber(data.cart_total) !== 0) { $('#invalid-promo').css('display', 'block') }
    $('#discount').text("$0.00");
    $('.payment-summary .discount').removeClass('d-flex').hide();
  } else {
    $('#invalid-promo').css('display', 'none');
    var youSaved = data.cart_discount_total;
    $('#discount').text(youSaved);
    $('.payment-summary .discount').show();
    var codeDis = $("#promotion_code").val();
    if(codeDis.length > 0) {
      $('.promo-payment-drop').html('<p class="em2 promo-applied-msg" style="">Promo code &#34;' + codeDis + '&#34; applied</p>');
    }
    sessionStorage.setItem("promo_primary", codeDis);
  }
}

function addOrderPromotion(promoCode) {
  if (promoCode == null) { return }

  return RegistriaShoppingCart.addOrderPromotion(promoCode, {
    success: function (data) {
      window.shoppingCart = data;
      if (data.promotion_type === "free_shipping" || data.promotion_type === "grouped_coupon") {
        applyShippingPromotion(data)
      } else {
        applyOrderLinePromotion(data)
      }
      $("#total").html(data.cart_total);
    },
    error: function (data) {
      $('#invalid-promo').css('display', 'block');
    }
  })
}

function addPromotion(code) {
  addOrderPromotion(code)
      .then(calculateTax, ajaxFinished)
      .then(function () { return calculateShipping(); }, ajaxFinished)
      .done(ajaxFinished)
}

// Cart
function updateLines(items) {
  for (item in items) {
    if (items.hasOwnProperty(item)) {
      var element = items[item];
      var $purchasable = $("#" + element.sku);
      $purchasable.data("target", element.line_number);
      $purchasable.find(".line_subtotal .cart-total-mid").html(element.cart_item_sub_total);
      // ("body").find(".cart-totals-total #total").html(element.cart_item_sub_total);
      $("body").find(".cart-price-subtotal").html(element.cart_item_sub_total);
      $purchasable.find(".cart_item_quantity").data("currentQuantity", element.quantity)
      $purchasable.find('.remove_line').data("line", element.line_number);
    }
  }
}

// Add or Update Cart
function emptyCart() {
  return RegistriaShoppingCart.emptyCart();
}

function updateCartItemCount() {
  $(".cart_count").html(window.shoppingCart.cart_total_items);
}

function updatePromos(e) {
   if(e == 0 || e == '0.0' || e == '' || e == null || e == '-') {
     var promoCodeVal = sessionStorage.getItem('promo_primary');
     if(promoCodeVal != null || promoCodeVal > 0) {
       sessionStorage.removeItem('promo_primary');
       $('.promo-status').html('<p>Promo removed.</p>');
       $('.promo-applied-msg').hide();
     }
   }
}

function removeLine(el) {
  var $el = el;
  var lineNumber = $el.data("line");
  var sku = $el.data("sku");
  var pathname = window.location.pathname;
  var segments = pathname.split('/');
  var regId = segments.pop() || segments.pop();

  return RegistriaShoppingCart.removeLine(lineNumber, {
    success: function (data) {
      window.shoppingCart = data;
      var itemsCount = data.cart_total_items;
      var subtotal = data.cart_sub_total;
      var tax = data.cart_tax;
      var total1 = data.cart_total;
      var items = data.shopping_cart_items;
      $("#cart_total_items span").html(pluralize(itemsCount, "Item", "Items"));
      $("#subtotal").html(subtotal);
      $("#tax").html(tax);
      $("#" + sku).remove();
      updateCartItemCount();
      updateLines(items);
      var discount = data.cart_coupon_discount_total;
      updatePromos(discount);
      if(itemsCount == 0) {
        window.location.replace("/reg_thanks/" + regId);
      }
    }
  })
}

function incrementLine(el, quantity) {
  var $el = el;
  var lineNumber = $el.data("line");
  var regId = $el.data("regid");
  var sku = $el.data("sku");

  return RegistriaShoppingCart.incrementLine(lineNumber, quantity, {
    data: {
      purchasable_sku: sku,
      registration_id: regId
    },
    success: function (data) {
      window.shoppingCart = data;
      var itemsCount = data.cart_total_items;
      var subtotal = data.cart_sub_total;
      var total1 = data.cart_total;
      var items = data.shopping_cart_items;
      var youSaved = data.cart_discount_total;
      $('#discount').text(youSaved);
      $("#cart_total_items span").html(pluralize(itemsCount, "Item", "Items"));
      $("#subtotal").html(subtotal);
      $("#total").html(total1);
      updateCartItemCount();
      updateLines(items);
    }
  })
}

function decrementLine(el, quantity) {
  var $el = el;
  var lineNumber = $el.data("line");
  var regId = $el.data("regid");
  var sku = $el.data("sku");

  return RegistriaShoppingCart.decrementLine(lineNumber, quantity, {
    data: {
      purchasable_sku: sku,
      registration_id: regId
    },
    success: function (data) {
      window.shoppingCart = data;
      var itemsCount = data.cart_total_items;
      var subtotal = data.cart_sub_total;
      var total1 = data.cart_total;
      var items = data.shopping_cart_items;
      var youSaved = data.cart_discount_total;
      $('#discount').text(youSaved);
      $("#cart_total_items span").html(pluralize(itemsCount, "Item", "Items"));
      $("#subtotal").html(subtotal);
      $("#total").html(total1);
      updateCartItemCount();
      updateLines(items);
    }
  })
}

function updateLineQuantity(el) {
  var $el = el;
  var currentQuantity = $el.data("currentQuantity");
  var newQuantity = toNumber($el.val());

  if (newQuantity === currentQuantity) { return }
  if (newQuantity < currentQuantity) { return decrementLine($el, currentQuantity - newQuantity); }
  if (newQuantity > currentQuantity) { return incrementLine($el, newQuantity - currentQuantity); }
  var youSaved = data.cart_discount_total;
  $('#discount').text(youSaved);
}

function updateLineFrequency(el) {
  var $el = el;
  var currentFrequency = $el.data("subid");
  var newFrequency = toNumber($el.val());
  var sku = $el.data("sku");
  var registration = $el.data("regid");

  if (newFrequency === currentFrequency) { return }

  return RegistriaShoppingCart.updateLine({
    data: {
      purchasable_sku: sku,
      registration_id: registration,
      subscription_id: newFrequency
    },
    success: function (data) {
      window.shoppingCart = data;
    }
  })
}

// Cart Init
function initCart() {
  return RegistriaShoppingCart.init({
    success: function (data) {
      window.shoppingCart = data;
    }
  })
}


function init() {
  initCart()
    .then(function () { return shippingEstimate(); }, ajaxFinished)
    .then(function () { return addOrderPromotion(window.shoppingCart.cart_free_shipping_promotion); }, ajaxFinished)
    .then(function () { return calculateTax(); }, ajaxFinished)
    .then(function () { return calculateShipping(); }, ajaxFinished)
    .always(function () { return ajaxFinished(); });
}

$(".remove_line").on("click", function(e) {
  removeLine($(this))
      .then(calculateTax)
      .then(shippingEstimate)
      .then(gtmCartRemove(this))
        .always(function () { return ajaxFinished(); })
  return RegistriaShoppingCart.init({
    success: function (data) {
      window.shoppingCart = data;
      var itemsCount = data.cart_total_items;
      var regid = $(this).data('regid');
    }
  });
});

console.log("SUB TOTAL: ");


$(".cart_item_quantity").on("focusin", function(e) {
  $(this).data('qtyval', $(this).val());
});

$(".cart_item_quantity").on("change", function(e) {
  updateLineQuantity($(this))
      .promise()
      .then(calculateTax)
      .then(shippingEstimate)
      .then(gtmCartTrack(this))
      .always(function () { return ajaxFinished(); })
});

$(".cart_item_subscription_frequency").on("change", function (e) {
  updateLineFrequency($(this))
    .promise()
    .always(function () { return ajaxFinished(); })
});

$('#apply-promo').on('click', function (event) {
  event.preventDefault();

  var code = $("#promotion_code").val();

  if (code.length < 1) { return }

  addPromotion(code);
})

$(function() {
  init();
})

$('.promo-payment-drop button').removeClass('btn').removeClass('btn-secondary').addClass('text-danger');
$('.promo-payment-drop .col-md-6').addClass('col-md-9').removeClass('col-md-6');
